import { render, staticRenderFns } from "./formBuilderNewView.vue?vue&type=template&id=521a948e&scoped=true"
import script from "./formBuilderNewView.vue?vue&type=script&lang=js"
export * from "./formBuilderNewView.vue?vue&type=script&lang=js"
import style0 from "./formBuilderNewView.vue?vue&type=style&index=0&id=521a948e&prod&lang=scss&scoped=true"
import style1 from "./formBuilderNewView.vue?vue&type=style&index=1&id=521a948e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a948e",
  null
  
)

export default component.exports